import { FC } from 'react'

import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { useCreateCampaignEvents } from 'src/Hooks/Analytics/useCreateCampaignEvents'
import { usePageViewEvent } from 'src/Hooks/Analytics/usePageViewEvent'
import { pageInfo } from 'src/Helpers/TagManager/pageInfo'
import { useCreateCampaignStartEvent } from 'src/Hooks/Analytics/useCreateCampaignStartEvent'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { ArtistRoutesEnum } from 'src/Router/ArtistComponentsNewUI'
import { APP } from 'src/Configs/App'
import IconSpotify from 'src/Assets/Svg/spotify.svg?react'
import TikTokIcon from 'src/Assets/Svg/tiktok.svg?react'
import TikTokIconLight from 'src/Assets/Svg/tiktok_light.svg?react'
import MetaAdsIcon from 'src/Assets/Svg/platform-icons/MetaAds.svg?react'
import { useThemeMode } from 'src/Hooks/useThemeMode'

import { CreateNewCampaignHelmet } from '../../Components/CreateNewCampaignHelmet'
import { CreateCampaignBreadcrumbsAuth } from '../../Components/CreateCampaignBreadcrumbsAuth'
import { PlatformButton } from '../../Components/PlatformButton'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  max-width: 960px;
`

const PlatformsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
  align-self: stretch;
`

export const ChoosePlatformAuthPage: FC = () => {
  const navigate = useNavigate()
  const { resolvedTheme } = useThemeMode()
  const TikTok = resolvedTheme === 'dark' ? TikTokIconLight : TikTokIcon
  const { campaignCreationStartMpEventHandler } = useCreateCampaignEvents()
  usePageViewEvent(pageInfo.createCampaign)
  useCreateCampaignStartEvent()

  const onSpotifyClick = (): void => {
    campaignCreationStartMpEventHandler({
      platformType: CampaignPlatformTypeEnum.SPOTIFY,
    })

    navigate(
      APP.PRE_RELEASE_CAMPAIGNS_ENABLED
        ? ArtistRoutesEnum.ChooseCreateCampaignReleaseType
        : ArtistRoutesEnum.ChooseCreateCampaignPlatformSpotify,
    )
  }
  const onTikTokClick = (): void => {
    campaignCreationStartMpEventHandler({
      platformType: CampaignPlatformTypeEnum.TIKTOK,
    })

    navigate(`${ArtistRoutesEnum.ChooseCreateCampaignPlatformTikTok}`)
  }

  const onAdsClick = (): void => {
    campaignCreationStartMpEventHandler({
      platformType: CampaignPlatformTypeEnum.META,
    })
    navigate(`${ArtistRoutesEnum.CreateAds}`)
  }
  return (
    <>
      <CreateNewCampaignHelmet />
      <Container>
        <CreateCampaignBreadcrumbsAuth />
        <PlatformsContainer>
          <PlatformButton
            icon={IconSpotify}
            title='Spotify Campaign'
            onClick={onSpotifyClick}
          />
          <PlatformButton
            icon={TikTok}
            title='TikTok Campaign'
            onClick={onTikTokClick}
          />
          {APP.ENABLE_META_ADS && (
            <PlatformButton
              icon={MetaAdsIcon}
              title={'Meta Ads Campaign'}
              onClick={onAdsClick}
            />
          )}
        </PlatformsContainer>
      </Container>
    </>
  )
}
